import { connect } from 'react-redux';
import React from 'react';
import PropTypes from 'prop-types';
import NavigationMenu from '../Menu/NavigationMenu.jsx';
import actions from '../actions.js';
import scoutLogo from '../../../assets/images/immoscout24.svg';

const SidebarExpandedMobile = ({ onClickClose }) => (
  <div className="background-white" style={{ position: 'absolute', zIndex: 999, height: '100vh' }}>
    <div className="grid grid-flex grid-align-center grid-justify-space-between border-bottom padding-m">
      <div className="grid-item padding-s padding-top-m padding-left-m">
        <a href="https://www.immobilienscout24.de/">
          <img src={scoutLogo} alt="scoutLogo" style={{ width: '126px' }} />
        </a>
      </div>
      <div className="grid-item align-right padding-s">
        <span
          className="is24-icon-closing font-h3 "
          onClick={onClickClose}
          role="button"
          onKeyDown={(event)=> {
            if (event.key === 'Escape'){
              onClickClose()
            }
          }}
          tabIndex={0} />
      </div>
    </div>
    <div>
      <NavigationMenu />
    </div>
  </div>
);

SidebarExpandedMobile.propTypes = {
  onClickClose: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  onClickClose: () => dispatch(actions.closeBurgerMenu()),
});

export default connect(null, mapDispatchToProps)(SidebarExpandedMobile);
